<router-outlet></router-outlet>

<jml-footer class="layout-footer"></jml-footer>
